import { ReactNode, useEffect } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';
import api from '@/api/services/achievements';
import { Typography } from '@/components/Atoms';
import { commanderQueryKey } from '@/components/CommandCenter/LeftBox/ArmiesSection/ArmiseList';
import CustomSkeleton from '@/components/Common/CustomSkeleton';
import { numberSeparator } from '@/utils/numberSeparator';
import TopBarAdditionalData from './TopBarAdditionalData';

type ItemProps = {
  icon: ReactNode;
  title: string;
  value: number;
};

const Item = (props: ItemProps) => (
  <div className='col-span-6 sm:col-span-4 md:col-span-3 lg:col-span-4 xl:col-span-3 flex items-center gap-[6px]'>
    <div className='w-[16px] h-[16px]'>{props.icon}</div>
    <div className='gap-2 flex items-center'>
      <Typography size='s12ToS12'>{props.title}:</Typography>
      <Typography size='s12ToS12' className='text-[#FF9900]'>
        {numberSeparator(props.value)}
      </Typography>
    </div>
  </div>
);

const TopBarArmySection = () => {
  const router = useRouter();

  const { [commanderQueryKey]: commanderQuery } = router.query;
  const filteredCommanderQuery = typeof commanderQuery === 'string' ? commanderQuery : null;

  const { data, isLoading } = api.useCommanderDetail({ commander_id: filteredCommanderQuery });

  const commanderData = data?.data?.data?.[0];

  useEffect(() => {
    const myCommanderData = data?.data?.data?.[0];
    if (!myCommanderData && !isLoading) {
      router.push('/command-center');
    }
  }, [data?.data?.data, isLoading, router]);

  return (
    <>
      {filteredCommanderQuery && (isLoading || commanderData) && (
        <TopBarAdditionalData
          onBackButtonClick={() => {
            const newQuery = { ...router.query };
            if (newQuery[commanderQueryKey]) {
              delete newQuery[commanderQueryKey];
            }
            router.push({ pathname: '/command-center', query: newQuery }, undefined, { shallow: true });
          }}
        >
          <div className='grid grid-cols-12 w-full'>
            <div className='col-span-12 md:col-span-2 2xl:col-span-3 flex items-center'>
              <div className='flex items-center gap-2'>
                <CustomSkeleton visible={isLoading}>
                  <div className={classNames('relative aspect-square h-11 rounded-md', isLoading && 'bg-black')}>
                    {commanderData && (
                      <Image src={commanderData.badge.Image} layout='fill' className='w-full h-full object-contain' alt='Badge image' />
                    )}
                  </div>
                </CustomSkeleton>

                <CustomSkeleton visible={isLoading}>
                  <Typography size='s16ToS14' className='flex-shrink-0 font-bold'>
                    {commanderData?.username || 'User name'}
                  </Typography>
                </CustomSkeleton>
              </div>
            </div>
            {/* <div className={'col-span-12 md:col-span-10 2xl:col-span-9 grid grid-cols-12 gap-y-2'}>
              <Item icon={<ScrollSvg />} title='Total Armies' value={1502} />
            </div> */}
          </div>
        </TopBarAdditionalData>
      )}
    </>
  );
};

export default TopBarArmySection;
